import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@wit-support/ui';
import { money, pct, signedMoneyWhole } from '../format.js';
const RED = 'text-[var(--color-state-danger-fg)]';
const GREEN = 'text-[var(--color-state-success-fg)]';
const MUTED = 'text-[var(--color-text-muted)]';
/** Цена покупки: красная, если дороже «в ноль». */
export function CppCell({ cpp, breakeven, className, }) {
    const dear = cpp !== null && breakeven !== null && cpp > breakeven;
    return (_jsx("span", { className: cn('font-semibold tabular-nums', dear && RED, className), title: dear ? 'Дороже, чем «в ноль»' : undefined, children: money(cpp) }));
}
/** «Не хватает / запас», $: красный < 0, зелёный ≥ 0, серый при «мало покупок». */
export function GapCell({ gap, verdict }) {
    const tone = verdict === null || gap === null ? MUTED : gap < 0 ? RED : GREEN;
    return _jsx("span", { className: cn('tabular-nums', tone), children: signedMoneyWhole(gap) });
}
/** Шанс окупиться; при «мало покупок» — «мало». */
export function ChanceCell({ p, verdict }) {
    if (verdict === null)
        return _jsx("span", { className: MUTED, children: "\u043C\u0430\u043B\u043E" });
    return _jsx("span", { className: "tabular-nums", children: pct(p) });
}
export const toneClass = { red: RED, green: GREEN, muted: MUTED };
//# sourceMappingURL=money-cells.js.map